import {
    GET_ALL_DETAILS_FOR_DISPATCH, GET_ALL_DETAILS_FOR_DISPATCH_ERROR,
    GET_ALL_PO_ITEM_DETAILS, GET_ALL_PO_ITEM_DETAILS_ERROR,
    REQUEST_PO_DISPATCH_CLEARANCE, REQUEST_PO_DISPATCH_CLEARANCE_ERROR,
    GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER, GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_ERROR,
    GET_PO_DETAILS_FOR_DISPATCH_MATERIAL, GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_ERROR,
    UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS, UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS_ERROR,
    GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL, GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_PO_HEADER_ERROR,
    GENERATE_DISPATCH_CLEARENCE, GENERATE_DISPATCH_CLEARENCE_ERROR,
    GET_GRN_PO_HEADER, GET_GRN_PO_HEADER_ERROR, GET_GRN_PO_LINE_ITEM, GET_GRN_PO_LINE_ITEM_ERROR,
    INSERT_DISPATCH_TEMPLATE_DATA, INSERT_DISPATCH_TEMPLATE_DATA_ERROR,
    GET_DISPATCH_TEMPLATE_MASTER_DATA, GET_DISPATCH_TEMPLATE_MASTER_DATA_ERROR,
    POST_DISPATCH_TEMPLATE_MASTER_DATA, POST_DISPATCH_TEMPLATE_MASTER_DATA_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4_ERROR,
    GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH_ERROR,
    POST_DISPATCH_CLERANCE_DETAILS, POST_DISPATCH_CLERANCE_DETAILS_ERROR,
    GET_DISPATCH_TEMPLATE_DETAILS, GET_DISPATCH_TEMPLATE_DETAILS_ERROR,
    POST_BILLINGSCHEDULE_DETAILS, POST_BILLINGSCHEDULE_DETAILS_ERROR,
    GET_BILLINGSCHEDULE_DETAILS, GET_BILLINGSCHEDULE_DETAILS_ERROR,
    POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS, POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR,
    GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS, GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR,
    POST_DISPATCH_INVOICE_FOR_DC, POST_DISPATCH_INVOICE_FOR_DC_ERROR,
    POST_GRN_DETAILS_AGAINST_INVOICE, POST_GRN_DETAILS_AGAINST_INVOICE_ERROR,
    POST_VENDOR_DETAILS, POST_VENDOR_DETAILS_ERROR,
    Waive_Off_Inspection, Waive_Off_Inspection_ERROR,
    GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS,
    GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS_ERROR,
    GET_CUSTOMER_MASTER,
    GET_CUSTOMER_MASTER_ERROR,
    POST_CUSTOMER_MASTER,
    POST_CUSTOMER_MASTER_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';
// import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

export const getAllDetailsForDispatch = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}getAllDetailsForDispatch`,
            data: params
        })
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllPOItemDetails = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}getAllPOItemDetails`,
            data: params
        })
        dispatch({
            type: GET_ALL_PO_ITEM_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_PO_ITEM_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const requestPODispatchClearance = (param) => async dispatch => {
    console.log(param, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}request-po-dispatch-clearance`,
            data: param,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: REQUEST_PO_DISPATCH_CLEARANCE,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: REQUEST_PO_DISPATCH_CLEARANCE_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllDetailsOfPOForDispatchForSupplier = (params) => async dispatch => {
    console.log(params, "^^^^")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}getAllDetailsOfPOForDispatchForSupplier`,
            data: params
        })
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetDispatchMaterialPO = (UserId, RoleId, PurchaseOrderId) => async dispatch => {
    console.log(UserId, RoleId, "data:")
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}/getDispatchMaterialPO/${UserId}/${RoleId}/${PurchaseOrderId}`,
            // data:UserId,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: GET_PO_DETAILS_FOR_DISPATCH_MATERIAL,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetDispatchMaterialPOHeader = () => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}/getDispatchMaterialPOHeader`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_PO_HEADER_ERROR,
            payload: console.log(e),
        })
    }

}

export const GenerateSMSDocument = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/generateSMSDocument`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GENERATE_DISPATCH_CLEARENCE,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GENERATE_DISPATCH_CLEARENCE_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetGRNDetails = (PoId, GRNDocNo = 'NA') => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${PoId}/${GRNDocNo}/getGRNDetails-for-po`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_GRN_PO_HEADER,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_GRN_PO_HEADER_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetGRNPOLineItem = (UserId, RoleId, PurchaseOrderId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}/getGRNPOLineItem/${UserId}/${RoleId}/${PurchaseOrderId}`,
            // data:UserId,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: GET_GRN_PO_LINE_ITEM,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_GRN_PO_LINE_ITEM_ERROR,
            payload: console.log(e),
        })
    }

}


export const updateDispatchDocumentID = (DocumentId, DocumentTypeId, PoID, PoLineItemId, CurrentVersionId, approvalStatus) => async dispatch => {
    console.log(DocumentId, DocumentTypeId, PoID, PoLineItemId, CurrentVersionId, approvalStatus, "data:")
    var input = {
        DocumentId: DocumentId,
        DocumentTypeId: DocumentTypeId,
        PoID: PoID,
        PurchaseOrderLineItemId: PoLineItemId,
        CurrentVersionId: CurrentVersionId,
        approvalStatus: approvalStatus,
    }
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/updateDispatchDocumentID`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }
}
export const postDispatchTemplateDetails = (inputdata) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-dispatch-template-data`,
            data: inputdata,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: INSERT_DISPATCH_TEMPLATE_DATA,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: INSERT_DISPATCH_TEMPLATE_DATA_ERROR,
            payload: console.log(e),
        })
    }

}
export const getDefaultDispatchTemplateDetails = (inputdata) => async dispatch => {

    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}get-default-dispatch-template-details`,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const gettemplatemasterData = (input) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-dispatch-template-master-data`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: GET_DISPATCH_TEMPLATE_MASTER_DATA,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: GET_DISPATCH_TEMPLATE_MASTER_DATA_ERROR,
            payload: console.log(e),
        })
    }

}

export const getProjectEmpDetails = (input) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-Project-Emp-Details`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: GET_DISPATCH_TEMPLATE_MASTER_DATA,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: GET_DISPATCH_TEMPLATE_MASTER_DATA_ERROR,
            payload: console.log(e),
        })
    }

}

export const InserttemplatemasterData = (params) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-dispatch-template-master-data`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested For Dispatch",{icon:"success"})
        dispatch({
            type: POST_DISPATCH_TEMPLATE_MASTER_DATA,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: POST_DISPATCH_TEMPLATE_MASTER_DATA_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetPOAndLineItemListForDispatchCount = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-count`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPOAndLineItemListForDispatchonPONumber = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-On-PO`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPOAndLineItemListForDispatch = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetPOAndLineItemListForDispatchICListing = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-ICListing`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetPOAndLineItemListForDispatchForDCListing = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-DCListing`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPOAndLineItemListForDispatchBillingScheduleDetails = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-BillingScheduleDetails`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPOAndLineItemListForDispatchInspectionDetails = (searchData) => async dispatch => {
    // console.log("searchData-action", searchData)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-po-and-lineitem-list-InspectionDetails`,
            data: searchData,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4_ERROR,
            payload: console.log(e),
        })
    }
}
export const postDispatchClearenceDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-dispatch-clerance-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_DISPATCH_CLERANCE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_DISPATCH_CLERANCE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetDispatchDetailsByTemplateId = (TemplateId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${TemplateId}/get-dispatch-template-data`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_DISPATCH_TEMPLATE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_DISPATCH_TEMPLATE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const InsertBillingScheduleDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-billing-schedule-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_BILLINGSCHEDULE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_BILLINGSCHEDULE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const getBillingScheduleDetails = (PoLineItemId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${PoLineItemId}/get-billing-schedule-details`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_BILLINGSCHEDULE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_BILLINGSCHEDULE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const InsertBillingScheduleDescriptionDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-billing-schedule-description-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const getBillingScheduleDescriptionDetails = (PoLineItemId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${PoLineItemId}/get-billing-schedule-description-details`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const postSubmitInvoiceDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-invoice-details-for-dc`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_DISPATCH_INVOICE_FOR_DC,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_DISPATCH_INVOICE_FOR_DC_ERROR,
            payload: console.log(e),
        })
    }
}
export const postGRNDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-grn-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_GRN_DETAILS_AGAINST_INVOICE,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_GRN_DETAILS_AGAINST_INVOICE_ERROR,
            payload: console.log(e),
        })
    }
}
export const VendorDetails = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}VendorDetails`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_VENDOR_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_VENDOR_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const WaiveOffInspection = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}WaiveOffInspection`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: Waive_Off_Inspection,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: Waive_Off_Inspection_ERROR,
            payload: console.log(e),
        })
    }
}

export const postCustomerMaster = (params) => async dispatch => {
    console.log("oiuygfeds",params)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}post-customer-master`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_CUSTOMER_MASTER,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: POST_CUSTOMER_MASTER_ERROR,
            payload: console.log(e),
        })
    }
}

export const getCustomerMaster = () => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-customer-master`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_CUSTOMER_MASTER,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        dispatch({
            type: GET_CUSTOMER_MASTER_ERROR,
            payload: console.log(e),
        })
    }
}
